<template>
  <v-card
    class="half-radius pa-2 border custom-note"
    :class="absolute ? 'absolute-note' : 'fixed-note'"
  >
    <span class="title custom-text">Your Grade: {{ computedNote }}</span>
    <v-icon color="#29284c" class="pb-1" right>mdi-calendar-edit</v-icon>
  </v-card>
</template>
<script>
export default {
  props: {
    note: String,
    absolute: Boolean,
  },
  computed: {
    small() {
      return this.$vuetify.breakpoint.xs;
    },
    computedNote() {
      if (this.note > 6) return "A";
      let notes = ["F", "E", "D", "C", "B", "A"];
      return notes[this.note - 1];
    },
  },
};
</script>
<style scoped>
.border {
  border: 2px dashed #29284c;
}
.fixed-note {
  position: fixed;
  bottom: 1rem;
  right: 1rem;
}
.absolute-note {
  position: absolute;
  bottom: 1rem;
  right: 1rem;
}
.custom-note {
  max-width: 200px;
}
</style>
